<template>
	<transition name="slide-fade" appear>
		<div class="alert bg-danger text-white">
			<slot></slot>
		</div>
	</transition>
</template>

<script>
	export default {

	}
</script>